import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledNav = styled.nav`
	position: relative;
	display: flex;
	justify-content: ${({ $center }) => ($center ? 'center' : 'space-between')};
	align-items: center;
	width: 100%;
	height: 50px;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.background};
	border-bottom: 1px solid #e9e9e9;
`;

export const StyledIconGroup = styled.div`
	position: relative;
	bottom: 2px;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: flex-end;
`;

export const StyledCircle = styled.span`
	position: absolute;
	top: -5px;
	right: -5px;
	border: 1px solid ${({ theme }) => theme.colors.primaryLight};
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.primaryLight};
	width: 10px;
	height: 10px;
`;
